import { Prompt } from '../../../components/Prompt/Prompt.component';
import { AssessmentSessionProcessTypeId } from '../../../services/exams/assessmentSession/assessments.types';
import { getProcessLabel } from '../../../utils/assessmentSessionProcess';

export interface DownloadLimitModalProps {
  open: boolean;
  isCardLimit: boolean;
  noMoreCards: boolean;
  processTypeId: AssessmentSessionProcessTypeId;
  handleClose: () => void;
}

const DownloadLimitModal: React.FC<DownloadLimitModalProps> = (props) => {
  return (
    <Prompt
      open={props.open}
      size="xs"
      type="info"
      onConfirm={props.handleClose}
      mainActionButtonText="Powrót do listy"
      mainText={
        <>
          {props.isCardLimit && (
            <>Osiągnięto limit kart rozwiązań do oceny w {getProcessLabel(props.processTypeId).inProcess}</>
          )}
          {props.noMoreCards && (
            <>
              Aktualnie w systemie nie ma kart do pobrania. <br /> Spróbuj pobrać później.
            </>
          )}
        </>
      }
    />
  );
};

export default DownloadLimitModal;
